import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
var Loader = function Loader(props) {
  var _props$containerClass = props.containerClassName,
    containerClassName = _props$containerClass === void 0 ? "" : _props$containerClass,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    _props$size = props.size,
    size = _props$size === void 0 ? "small" : _props$size,
    label = props.label;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("flex flex-col items-center justify-center py-5 text-gray-500 gap-2", _defineProperty({}, containerClassName, !!containerClassName))
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("border-solid border-gray-400 border-r-transparent animate-spin inline-block rounded-full", _defineProperty({
      "border-2 w-4 h-4": size === "small",
      "border-2 w-6 h-6": size === "medium",
      "border-2 w-8 h-8": size === "large"
    }, className, !!className)),
    role: "status"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Loading...")), !!label && /*#__PURE__*/React.createElement("span", {
    className: classNames("", {
      "text-sm": size === "small",
      "text-md": size === "medium",
      "text-base": size === "large"
    })
  }, label));
};
export default Loader;